import { render } from "./CreateTicketForm.vue?vue&type=template&id=04ff7ca1"
import script from "./CreateTicketForm.vue?vue&type=script&lang=js"
export * from "./CreateTicketForm.vue?vue&type=script&lang=js"

import exportComponent from "/tmp/build_d537e74c/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__